export default "__VITE_ASSET__00ba0ffc__"